/**
 * Determines if a carousel template contains dynamic text parameters
 * ({{N}} placeholders) that campaigns cannot resolve at send time.
 * Static text parameters (no {{N}}) are not variables.
 *
 * @param {object|null|undefined} template — Template object from API
 * @returns {boolean} true if the carousel has dynamic {{N}} text params in its cards
 */
export const isCarouselWithParams = (template) => {
  if (template?.type?.toUpperCase() !== 'CAROUSEL') return false;

  if (!Array.isArray(template.components)) return false;

  const carouselComp = template.components.find((c) => c.type === 'carousel');
  if (!carouselComp?.cards) return false;

  return carouselComp.cards.some((card) =>
    card.components?.some((comp) =>
      comp.parameters?.some((p) => p.type === 'text' && /\{\{\d+\}\}/.test(p.text ?? ''))
    )
  );
};
